import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export function useAMCInstance() {
  return useQuery({
    queryKey: ["amcInstance"],
    queryFn: async () => await apiClient.getAMCInstances(),
    select: (data) => data[0] ?? null,
  });
}
